module.exports = __webpack_public_path__ + "static/media/直通车2.573ecebe.png";